import React, { useEffect, useState } from 'react';
import Icon from '../icons';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    children?: any;
    position?:string
}
interface MenuProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: any;
    icon?: any;
    onClick?: () => void;
    disabled?: boolean;
}
export const Menu: React.FC<MenuProps>  = ({ children , icon, onClick, disabled}) => {
    return (
        <button type='button' disabled={disabled} onClick={!disabled ? onClick : undefined}
      className={`w-full flex items-center gap-2 h-8 max-w-[250px] p-1 rounded-sm 
        ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer hover:bg-slate-100"}`}>
            <p className='text-[0.813rem] text-left font-normal whitespace-nowrap leading-none w-full truncate' title={children}>{children}</p>
        </button>
    );
};

export const Dropdown: React.FC<Props> & {
    Button: React.FC<Props>
    Content: React.FC<Props> 
} = ({ children, position = 'end' }) => {
    
    const Button = children?.find?.((child:any) => child.type.displayName === 'Dropdown.Button') || null;
    const Content = children?.find?.((child:any) => child.type.displayName === 'Dropdown.Content') || null;

    return (
        <div className={`dropdown dropdown-bottom dropdown-${position}`}>
            {Button}
            <div className="dropdown-content bg-white border border-slate-200  overflow-auto max-h-[15rem] rounded-md z-50 min-w-52 w-auto p-2 shadow-md">
                {Content}
            </div>
        </div>
    );
};

Dropdown.Button = ({children}) => {
    return (<>{children}</>);
}

Dropdown.Content = ({children}:Props) => {
    return (<>{children}</>);
}

Dropdown.Button.displayName = 'Dropdown.Button';
Dropdown.Content.displayName = 'Dropdown.Content';

